import { useQuery } from 'react-query';
import axios from 'axios';
import { env } from 'src/config/env';

const getFormResponses = async (providerId) => {
  const response = await axios.get(`${env.PROVIDER_ONBOARDING_API}/v1/form_responses`, {
    params: {
      organization_id: providerId,
    },
  });

  return response.data.data;
};

export const useFormResponses = ({ providerId }) => useQuery(
  ['form_responses', providerId],
  () => getFormResponses(providerId),
  {
    staleTime: 10 * 60 * 1000,
    refetchInterval: 10 * 60 * 1000,
    retry: false,
  },
);
